<bit-simple-dialog hideIcon>
  <span bitDialogTitle>{{ "transferItemsToOrganizationTitle" | i18n: organizationName }}</span>

  <span bitDialogContent>
    {{ "transferItemsToOrganizationContent" | i18n: organizationName }}
  </span>

  <ng-container bitDialogFooter>
    <button bitButton type="button" buttonType="primary" (click)="acceptTransfer()">
      {{ "acceptTransfer" | i18n }}
    </button>

    <button bitButton type="button" buttonType="secondary" (click)="decline()">
      {{ "declineAndLeave" | i18n }}
    </button>

    <a bitLink href="#" (click)="openLearnMore($event)" class="tw-self-center tw-text-sm">
      {{ "whyAmISeeingThis" | i18n }}
      <bit-icon name="bwi-external-link" class="tw-ml-1"></bit-icon>
    </a>
  </ng-container>
</bit-simple-dialog>
